const Introduction = () => {
  return (
    <div className="flex-1 mt-20">
      <h1 className="text-white text-3xl font-bold mb-9 lg:text-5xl">
        Learn to code by watching others
      </h1>
      <p className="text-white mb-[70px]">
        See how experienced developers solve problems in real-time. Watching
        scripted tutorials is great, but understanding how developers think is
        invaluable.
      </p>
    </div>
  );
};

export default Introduction;
